import { ComponentType, FC, ReactElement } from 'react';

import { UserPrivilegeName } from 'domain/UserProfile';
import { useAuthorization } from 'modules/authorization/hooks';

interface WithPrivilegeDependencyProps {
  privilegeAvailability?: UserPrivilegeName[];
  withNoCommunity?: boolean;
  withCommunity?: boolean;
  forCompanyAdmin?: boolean;
  forCompanyAndCommunityAdmin?: boolean;
}

export const withPrivilegeDependency =
  <P extends object>(WrappedComponent: ComponentType<P>): FC<P & WithPrivilegeDependencyProps> =>
  ({
    privilegeAvailability = [],
    withNoCommunity,
    withCommunity,
    forCompanyAdmin,
    forCompanyAndCommunityAdmin,
    ...props
  }): ReactElement | null => {
    const { hasPrivilege, isWithoutCommunity, isCompanyAdmin, isCommunityAdmin } = useAuthorization();

    if (
      hasPrivilege(privilegeAvailability) ||
      (withNoCommunity && isWithoutCommunity) ||
      (withCommunity && !isWithoutCommunity) ||
      (forCompanyAdmin && isCompanyAdmin) ||
      (forCompanyAndCommunityAdmin && isCompanyAdmin && isCommunityAdmin)
    ) {
      return <WrappedComponent {...(props as P)} />;
    }

    return null;
  };
